<app-shared-dialog [options]="{
    confirmText: 'agent.actions.assign_catalog' | translate,
    confirmIcon: 'plus-cc',
    confirmIconPosition: 'start',
    cancelText: 'common.cancel' | translate,
    size: 'large'
  }" (confirm)="save()"
    (cancel)="cancel()">
    <div class="dialog-header">
      {{ 'agent.catalogue.add_catalogs_title' | translate }}
    </div>
    <app-agent-catalogs-list
      [initialSelectedCatalogs]="initialSelectedCatalogs"
      (selectedCatalogsChange)="selectedCatalogsChange($event)"
    ></app-agent-catalogs-list>
  </app-shared-dialog>